import "./reporte_cuenta_cobrar.css";
export { default as ListadoCuentaCobrar } from "./Listado";
export { default as DetalleCuentaCobrar } from "./Detalle";
